import { render } from "./sglm-committee.vue?vue&type=template&id=0476a2bd&scoped=true"
import script from "./sglm-committee.vue?vue&type=script&lang=js"
export * from "./sglm-committee.vue?vue&type=script&lang=js"

import "./sglm-committee.vue?vue&type=style&index=0&id=0476a2bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0476a2bd"]])

export default __exports__